export enum SupervisorSupervisionsTabs {
    MySupervisions = 'my-supervisions',
    Proposals = 'proposals',
}
